import React, { memo, useCallback } from 'react';
import { useField, useFormikContext } from 'formik';
import Select from 'react-select';
import { Form } from 'react-bootstrap';

import { FieldLabel } from 'src/libs/ui-kit';
import { useStore } from 'src/modules/users/hooks/useStore';

import { ILoyaltyBonusOperationFormValues, ILoyaltyBonusOperationReasonOption } from '../interfaces';

import { StoreContext } from './StoreProvider';

export const ReasonSelect = memo(() => {
  const store = useStore(StoreContext);

  const { initialValues, setValues } = useFormikContext<ILoyaltyBonusOperationFormValues>();

  const [fieldProps] = useField<null | ILoyaltyBonusOperationReasonOption>('reason');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onReasonChange = useCallback<(value: any) => void>(
    (reason: null | ILoyaltyBonusOperationReasonOption) => setValues({ ...initialValues, reason }),
    [initialValues, setValues],
  );

  return (
    <Form.Group>
      <FieldLabel label="Причина изменения" />
      <Select
        {...fieldProps}
        className="react-select"
        classNamePrefix="react-select"
        placeholder="Выберите причину"
        getOptionLabel={getReasonOptionLabel}
        getOptionValue={getReasonOptionValue}
        isClearable={false}
        options={store.availableReasonOptions}
        onChange={onReasonChange}
        styles={SELECT_STYLES_FIX}
        menuPortalTarget={document.body}
      />
    </Form.Group>
  );
});

ReasonSelect.displayName = 'ReasonSelect';

const getReasonOptionLabel = ({ label }: ILoyaltyBonusOperationReasonOption) => String(label);
const getReasonOptionValue = ({ value }: ILoyaltyBonusOperationReasonOption) => String(value);

const SELECT_STYLES_FIX = {
  menuPortal: (base: React.CSSProperties) => ({ ...base, zIndex: 9999 }),
} as const;
